import React, { useState, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { Form, InputGroup, Button, Container, Row } from 'react-bootstrap';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import { setSettings, getSettings } from '../../services/Settings/settingsService';
import { usePermissions } from '../../hooks/usePermissions';
import { usePermissionsContext } from '../../context/PermissionsContext';

const Settings = () => {
  const { checkPermission, ToastComponent, hasPermission } = usePermissions();
  const { permissions } = usePermissionsContext();
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Recalcula permissões sempre que o objeto permissions mudar
  const canView = useMemo(() => hasPermission('configurationsView'), [hasPermission, permissions]);
  const canUpdate = useMemo(() => hasPermission('configurationsUpdate'), [hasPermission, permissions]);

  const loadSettings = async () => {
    if (!canView) return;
    try {
      const settings = await getSettings();
      const normalizedSettings = {
        balanceFile: settings.balanceFile || '',
      };
      
      setValue('balanceFile', normalizedSettings.balanceFile);
    } catch (error) {
      console.error('Erro ao carregar as configurações:', error);
      setErrorMessage(error.message || 'Erro ao carregar as configurações.');
      setShowErrorModal(true);
    }
  };

  useEffect(() => {
    loadSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (data) => {
    if (!checkPermission('configurationsUpdate')) {
      return;
    }
    try {
      await setSettings(data);
      setSuccessMessage('Configurações salvas com sucesso!');
      setShowSuccessModal(true);
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao salvar as configurações.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);

  if (!canView) {
    return (
      <>
        <ToastComponent />
        <Container>
          <h3 className="mb-4 mt-2 text-center text-md-start">Configurações</h3>
        </Container>
      </>
    );
  }

  return (
    <Container>
      <ToastComponent />
      <h3 className="mb-4 mt-2 text-center text-md-start">Configurações</h3>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="justify-content-between align-items-center mb-3">
          <Form.Group className="mb-3">
            <Form.Label className="mb-1">Arquivo txt da Balança:</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Informe o caminho do arquivo"
                {...register('balanceFile', {
                  required: 'O caminho do arquivo é obrigatório',
                  pattern: {
                    value: /.+\.txt$/,
                    message: 'O arquivo deve ser um .txt',
                  },
                })}
                isInvalid={!!errors.balanceFile}
                disabled={!canUpdate}
              />
              <Form.Control.Feedback type="invalid">
                {errors.balanceFile?.message}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </Row>
        {canUpdate && (
          <Button variant="primary" className="button-custom" type="submit">
            Salvar
          </Button>
        )}
      </Form>
      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </Container>
  );
};

export default Settings;